export class ResourcesHistoryFakeDb {
  public static history = [];
}
